









import Vue from "vue";
export default Vue.extend({
  props: ["labels"],
  computed: {
    show_pi_indicator(): boolean {
      // Lazy import to avoid evaluating shared state before plugin setup.
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const { SharedState } = require("@/common/state");
      return SharedState.FeatureHelper.is_enabled("show_pi_indicator");
    },
  },
});
